import { CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, InputNumber, message } from "antd";
import axios from "axios";
import { create } from "zustand";
import css from "./Pos.module.css";

const fmtSum = (v) => Number(v || 0).toLocaleString("ru-RU").replace(/,/g, " ");

// Debounce funksiyasini yaratish
const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
};

export const usePos = create((set, get) => ({
    coming: [],
    ed: {},

    possendData: {
        customer_id: null,
        payamount: 0,
        returnpay: 0,
        deliverysumm: 0,
        deliveraddress: '',
        amount: 0,
        currency: 'so"m',
        method: 'naqd',
        discount: 0,
        distype: '%',
        finalsum: 0,
        totalsum: 0,
        naqd: 0,
        plastik: 0,
        boshqa: 0,
    },

    checkPayAmount: (amount, method) => {
        if (method === 'naqd') {
            set({
                possendData: {
                    ...get().possendData,
                    naqd: amount
                }
            });
        } else if (method === 'plastik') {
            set({
                possendData: {
                    ...get().possendData,
                    plastik: amount
                }
            });
        } else {
            set({
                possendData: {
                    ...get().possendData,
                    boshqa: amount
                }
            });
        }
        get().updateSumms();
    },

    // Selektorlar - tez-tez ishlatiladigan hisoblar
    updateSumms: () => {
        let totalsum = get().selected.reduce((sum, item) => Number(sum) + Number(item.summa), 0);
        let discount = Number(get().possendData.discount);
        let distype = get().possendData.distype;
        let deliverysumm = Number(get().possendData.deliverysumm);
        let finalsum = totalsum - discount + deliverysumm;
        let returnpay = (Number(get().possendData.naqd) + Number(get().possendData.plastik) + Number(get().possendData.boshqa)) - finalsum;
        set({
            possendData: {
                ...get().possendData,
                totalsum: totalsum,
                discount,
                distype,
                deliverysumm,
                finalsum,
                returnpay
            }
        });
    },
    setDisType: (type) => {
        set({
            possendData: {
                ...get().possendData,
                distype: type
            }
        });
        get().updateSumms();
    },

    checkDiscount: (discount) => {
        if (get().possendData.distype === 'percent') {
            discount = +get().possendData.totalsum / 100 * discount;
        } else {
            discount = +discount;
        }

        let dissumma = Number(discount);
        set({
            possendData: {
                ...get().possendData,
                discount,
                dissumma
            }
        });
        get().updateSumms();
    },

    checkDeliverSumm: (summ) => {
        let deliverysumm = Number(summ);
        set({
            possendData: {
                ...get().possendData,
                deliverysumm
            }
        });
        get().updateSumms()
    },


    setPosSendData: (data, type) => {
        try {
            if (type === 'deliver') {
                set({
                    possendData: {
                        ...get().possendData,
                        deliverysumm: Number(data.deliverysumm),
                        deliveraddress: data.deliveraddress
                    }
                });
            } else if (type === 'discount') {
                const totalsum = get().gettotalsum();
                const dissumma = (data.distype === 'percent')
                    ? totalsum / 100 * data.discount
                    : data.discount;

                set({
                    possendData: {
                        ...get().possendData,
                        discount: dissumma,
                        distype: data.distype
                    }
                });
            } else if (type === 'pay') {
                const totalsum = +get().gettotalsum();
                set({
                    possendData: {
                        ...get().possendData,
                        payamount: Number(data.payamount),
                        returnpay: +totalsum - +get().possendData.discount + +get().possendData.deliverysumm - Number(data.payamount)
                    }
                });
            } else if (type === 'customer') {
                set({
                    possendData: {
                        ...get().possendData,
                        customer_id: data.customer_id,
                    }
                });
            } else if (type === 'paymethod') {
                set({
                    possendData: {
                        ...get().possendData,
                        method: data.method
                    }
                });
            }
        } catch (error) {
            message.error("Ma'lumotlarni o'zgartirishda xatolik yuz berdi");
        }
        set({ possendData: { ...get().possendData, amount: get().gettotalsum() } });
    },

    sitems: [],
    selected: [],

    setSelected: (s) => {
        try {
            // Do'kon skladidagi sotiladigan qoldiq (posSearch/posVariations -> shopcount)
            const maxCount = Number(s.shopcount ?? s.count ?? 0);

            if (maxCount <= 0) {
                message.warning("Bu tovar do'kon skladida yo'q. Asosiy skladdan so'rov bering.");
                return;
            }

            let sfind = get().selected.find((item) => item.id === s.id);
            if (sfind?.id) {
                if (sfind.count + 1 > sfind.maxcount) {
                    message.warning(`Do'kon skladida faqat ${sfind.maxcount} ta bor.`);
                    return;
                }
                const other = get().selected.filter((item) => item.id !== s.id);
                sfind.count = sfind.count + 1;
                sfind.summa = sfind.count * sfind.price;
                set({ selected: [...other, sfind] });
            } else {
                const ns = {
                    id: s.id,
                    p_id: s.id,
                    code: s.sku,
                    nameuz: s.product,
                    count: 1,
                    maxcount: maxCount,
                    price: Number(s.price_uzs),
                    summa: Number(s.price_uzs) * 1
                };
                set({ selected: [...get().selected, ns] });
            }
        } catch (error) {
            message.error("Mahsulotni qo'shishda xatolik yuz berdi");
        }
        get().updateSumms();
        // set({ possendData: { ...get().possendData, amount: get().gettotalsum() } });
    },

    // Debounce bilan qidiruv — DO'KON skladiga bog'langan (do'kon + asosiy qoldiq)
    searchItem: debounce(async (param) => {
        try {
            if (param.length >= 3) {  // Kamida 3 ta belgi kiritilgandan keyin qidirish
                const shop_id = localStorage.getItem('shop_id') || 'null';
                const response = await axios.get(`/pos/search/${shop_id}/${param}`);
                set({ sitems: response.data });
            }
        } catch (error) {
            message.error("Mahsulotlarni qidirishda xatolik yuz berdi");
        }
    }, 300),  // 300ms kutish

    reCount: (count, id) => {
        try {
            if (count <= 0) {
                get().handleRemoveProduct(id);
                return;
            }

            let sfind = get().selected.find((item) => item.id === id);
            let other = get().selected.filter((item) => item.id !== id);

            // Agar o'zgarish bo'lmasa, qayta render qilmaslik
            if (sfind.count === count) return;

            // Do'kon skladidagi qoldiqdan oshib ketmasin
            if (sfind.maxcount != null && count > sfind.maxcount) {
                message.warning(`Do'kon skladida faqat ${sfind.maxcount} ta bor.`);
                count = sfind.maxcount;
            }

            sfind.count = count;
            sfind.summa = sfind.count * sfind.price;

            set({ selected: [...other, sfind].sort((a, b) => a.id - b.id) });
        } catch (error) {
            message.error("Mahsulot sonini o'zgartirishda xatolik yuz berdi");
        }
        get().updateSumms();
    },

    rePrice: (price, id) => {
        try {
            let sfind = get().selected.find((item) => item.id === id);
            let other = get().selected.filter((item) => item.id !== id);

            // Agar o'zgarish bo'lmasa, qayta render qilmaslik
            if (sfind.price === Number(price)) return;

            sfind.price = Number(price);
            sfind.summa = sfind.count * sfind.price;

            set({ selected: [...other, sfind].sort((a, b) => a.id - b.id) });
        } catch (error) {
            message.error("Mahsulot narxini o'zgartirishda xatolik yuz berdi");
        }
        get().updateSumms();
    },

    handleRemoveProduct: (id) => {
        try {
            let other = get().selected.filter((item) => item.id !== id);
            set({ selected: other });
        } catch (error) {
            message.error("Mahsulotni o'chirishda xatolik yuz berdi");
        }
        get().updateSumms();
    },

    scolumns: [
        {
            title: 'Mahsulot',
            dataIndex: 'code',
            key: 'code',
            render: (_, rec) => <div className={css.cellCode}>
                <b>{rec.nameuz}</b>
                <span>{rec.code}</span>
            </div>
        },
        {
            title: 'Soni',
            dataIndex: 'count',
            key: 'count',
            width: 130,
            align: 'center',
            render: (_, rec) => <div className={css.qtyControl}>
                <Button type='text' size="small" onClick={() => { get().reCount(rec.count - 1, rec.id) }} icon={<MinusOutlined />} />
                <input type="number" value={rec.count} onChange={(e) => get().reCount(Number(e.target.value), rec.id)} />
                <Button type='text' size="small" onClick={() => { get().reCount(rec.count + 1, rec.id) }} icon={<PlusOutlined />} />
            </div>
        },
        {
            title: 'Narxi',
            dataIndex: 'price',
            key: 'price',
            width: 130,
            align: 'right',
            render: (_, rec) => <InputNumber
                className={css.priceInput}
                controls={false}
                min={0}
                value={rec.price}
                formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                parser={(v) => `${v}`.replace(/\s/g, '')}
                onChange={(v) => { get().rePrice(v ?? 0, rec.id) }}
            />
        },
        {
            title: 'Summa',
            dataIndex: 'subTotal',
            key: 'subTotal',
            width: 130,
            align: 'right',
            render: (_, rec) => <div className={css.cellSub}>{fmtSum(rec.count * rec.price)}</div>
        },
        {
            title: '',
            dataIndex: 'action',
            key: 'action',
            width: 48,
            align: 'center',
            render: (_, record) => {
                return <Button type='text' danger icon={<CloseOutlined />} onClick={() => get().handleRemoveProduct(record.id)} />
            },
        }
    ],

    create: async (data) => {
        try {
            await axios.post('/comin', data);
            message.success("Muvaffaqiyatli qo'shildi!");
            set({ selected: [] });
        } catch (error) {
            message.error("Ma'lumotlarni saqlashda xatolik yuz berdi");
        }
    },

    getComing: async () => {
        try {
            const response = await axios.get('/comin');
            set({ coming: response.data });
        } catch (error) {
            message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
        }
    },
    newSales: (values, form) => {
        let data = { ...get().possendData, items: get().selected, customer_id: values.customer_id, naqd: +values.naqd, plastik: +values.plastik, boshqa: +values.boshqa, deliveraddress: values.deliveraddress }
        let shop_id = localStorage.getItem('shop_id')
        data.shop_id = shop_id
        axios.post('/pos/sales', data)
            .then((res) => {
                message.success("Muvaffaqiyatli qo'shildi!");
                form.resetFields()
                set({ selected: [] });
                set({
                    possendData: {
                        customer_id: null,
                        payamount: 0,
                        returnpay: 0,
                        deliverysumm: 0,
                        deliveraddress: '',
                        amount: 0,
                        currency: 'so"m',
                        method: 'naqd',
                        discount: 0,
                        distype: '%',
                        finalsum: 0,
                        totalsum: 0,
                        naqd: 0,
                        plastik: 0,
                        boshqa: 0,
                    }
                });

            }).catch((error) => {
                message.error("Ma'lumotlarni saqlashda xatolik yuz berdi");
            })
    }
}))
